module.exports = __webpack_public_path__ + "img/coins-03.7a2aca49.svg";